import PropTypes from 'prop-types';
import React, { Component } from 'react';

import * as Shapes from '../../shapes';
import NotFound from '../../views/NotFound';
import PlayRadioButton from './PlayRadioButton';
import CapacitorHeaderBar from '../capacitor/HeaderBar';

import styles from './CategoryPage.css';
import FilteredRecordingList from './FilteredRecordingList';
import { compose } from 'redux';
import shareableEntity, { shareableEntityPropTypes } from '../../hoc/shareableEntity';
import ShareButton from './ShareButton';

class CategoryPage extends Component {
  static propTypes = {
    category: Shapes.Category.isRequired,
    filterParams: PropTypes.object.isRequired,
    activeFacets: PropTypes.array.isRequired,
    ignoredFacets: PropTypes.array.isRequired,
    recordings: PropTypes.arrayOf(Shapes.Recording).isRequired,

    location: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,

    contextId: PropTypes.string.isRequired,
    contextFacet: PropTypes.string.isRequired,
    showShareModal: PropTypes.func.isRequired,
    ...shareableEntityPropTypes,
  };

  renderHeader() {
    const { category, contextFacet, location, contextId, showShareModal } = this.props;

    const radioTrackingContext = {
      contextFilters: new URLSearchParams(location.query).toString(),
      contextId,
      contextTitle: contextFacet,
      contextFacet,
      contextType: 'Category',
    };

    return (
      <div className={styles.header}>
        <h1 className={styles.title}>{category.title}</h1>
        <PlayRadioButton
          type={contextFacet.toLowerCase()}
          id={category.id}
          trackingContext={radioTrackingContext}
          data-test="category-page.play-radio-btn"
        />
        {!__CAPACITOR__ && <ShareButton onClick={showShareModal} className={styles.shareBtn} />}
      </div>
    );
  }

  render() {
    const {
      contextId,
      contextFacet,
      category,
      location,
      params,
      filterParams,
      activeFacets,
      ignoredFacets,
      recordings,
    } = this.props;

    if (!category) {
      return <NotFound />;
    }

    return (
      <div className="category u-page-container">
        {__CAPACITOR__ && (
          <CapacitorHeaderBar
            title={category.title}
            onlyShowTitleOnScroll
            showShareModal={this.props.showShareModal}
          />
        )}
        {this.renderHeader()}
        <FilteredRecordingList
          location={location}
          params={params}
          contextId={contextId}
          contextFacet={contextFacet}
          filterParams={filterParams}
          activeFacets={activeFacets}
          ignoredFacets={ignoredFacets}
          recordings={recordings}
        />
      </div>
    );
  }
}

function getShareTrackingContext(props) {
  return {
    sharedContentType: props.contextFacet,
    sharedContentId: props.category.id,
    contextType: 'Category',
    contentId: props.category.id,
  };
}

const getEntityType = props => props.contextFacet.toLowerCase();

export default compose(shareableEntity(getEntityType, getShareTrackingContext))(CategoryPage);
